import React from 'react';

export interface SavedStateValue {
  saved: Set<string>;
  applied: Set<string>;
  viewed: Set<string>;
}

const SavedStateContext = React.createContext<SavedStateValue | null>(null);
export default SavedStateContext;


